// Unfortunately it looks like the text-encoding module always returns its implementations of
// TextEncoder and TextDecoder, so we wrap it here to expose the global (window) ones, if available.

import * as TextEncoding from 'text-encoding-utf-8';

export const TextEncoder = global.TextEncoder || TextEncoding.TextEncoder;
export const TextDecoder = global.TextDecoder || TextEncoding.TextDecoder;
